import { Money } from "../../api/types";
import { Button, Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import { DisplayMoney } from "../display-money";
import { useTranslation } from "react-i18next";
import Countdown from "react-countdown";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { useCheckout } from "../checkout/checkout-context";

export function PaymentSuccessful({
  total,
}: {
  total: Money;
  onPrintReceipt?: () => void;
}) {
  const [closeDate] = useState(() => Date.now() + 5000);
  const { closeSession, isCloseLoading } = useCheckout();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full items-center self-stretch p-8">
      <div className="flex-grow">
        <figure className="flex justify-center">
          <img src="/success.png" className="w-[100px] h-[100px]" />
        </figure>
        <Heading
          size="6"
          mb="2"
          align="center"
          weight="bold"
          color="gray"
          highContrast
        >
          {t("paymentSuccessful")}
        </Heading>
        <Flex gap="2" mb="2" justify="center">
          <Text size="4" color="gray">
            {t("amount")}: <DisplayMoney value={total} />
          </Text>
        </Flex>
      </div>
      <Flex
        className="w-full"
        direction="column"
        justify="between"
        gap="2"
        mt="4"
      >
        <Button
          className="w-full !relative !overflow-hidden"
          size="4"
          onClick={() => {
            if (!isCloseLoading) {
              closeSession();
            }
          }}
        >
          <Spinner loading={isCloseLoading} size="2"></Spinner>
          <span className="relative z-20">
            {!isCloseLoading ? t("closeCheckout") : t("closingCheckout")}
          </span>
          <span
            className={twMerge([
              "h-full !absolute top-0 left-0 bg-black/20 animate-payment-close transition-opacity",
              isCloseLoading && "opacity-0",
            ])}
          ></span>
        </Button>
        <Countdown
          date={closeDate}
          onComplete={closeSession}
          renderer={({ seconds }) => (
            <Text color="gray" align="center">
              Auto closing checkout in {seconds}...
            </Text>
          )}
        ></Countdown>
      </Flex>
    </div>
  );
}
